import { Hct, hexFromArgb } from '@material/material-color-utilities';

export const hueToLabelColor = (hue: number) => {
    const hctColor = Hct.from(hue, 36, 90);
    const hexColor = hexFromArgb(hctColor.toInt());
    return hexColor;
};
